export default __webpack_public_path__ + "static/media/logo-boleto-white.9730b8be.png";